import qs from 'qs'

import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

export interface ISigninQueryParams {
  redirect?: string
  platform?: string
  adpLogin?: string
  forgotpassword?: string
  error?: string
  code?: string
  /** Core or Complete, matched in any case. Any other value, the retired Free and Freemium included, is dropped and sign-up uses Complete. */
  subscriptionPlan?: SubscriptionPlanEnum
  /** Passed on as given: saving it is where anything but monthly or annual is dropped. */
  subscriptionPeriod?: string
}

/**
 * The query string minus `platform`, for leaving a focused step behind. Everything else is
 * kept: `redirect` decides where the sign-in lands, and dropping it would send the visitor
 * to the dashboard instead of the page they came for.
 */
export const searchWithoutPlatform = (search: string): string => {
  const parsed = qs.parse(search, { ignoreQueryPrefix: true })
  delete parsed.platform

  return qs.stringify(parsed, { addQueryPrefix: true })
}

const PRESELECTABLE_PLANS = [SubscriptionPlanEnum.core, SubscriptionPlanEnum.complete]

const readString = (value: unknown): string | undefined => (typeof value === 'string' && value ? value : undefined)

const readPlan = (value: unknown): SubscriptionPlanEnum | undefined => {
  const plan = readString(value)?.toLowerCase()
  return PRESELECTABLE_PLANS.find((preselectable) => preselectable.toLowerCase() === plan)
}

/**
 * Parsed once from the URL so the page can derive what it needs while rendering rather
 * than copying the URL into state from an effect.
 */
export const parseSigninQueryParams = (search: string): ISigninQueryParams => {
  const parsed = qs.parse(search, { ignoreQueryPrefix: true })

  return {
    redirect: readString(parsed.redirect),
    platform: readString(parsed.platform),
    adpLogin: readString(parsed.adpLogin),
    forgotpassword: readString(parsed.forgotpassword),
    error: readString(parsed.error),
    code: readString(parsed.code),
    subscriptionPlan: readPlan(parsed.subscriptionPlan),
    subscriptionPeriod: readString(parsed.subscriptionPeriod),
  }
}
